import { isDefinedString } from "et3-type-guards";

import i18n from "../../../../constants/i18n";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import {
  getAdminPasswordRuleChecks,
  isStrongAdminPassword
} from "../../../../helpers/et3-password-policy";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";
import {
  PASSWORD_CARD_BORDER,
  PASSWORD_CARD_GAP,
  PASSWORD_CARD_MAX_WIDTH_CSS,
  PASSWORD_CARD_MIN_PADDING_CSS,
  PASSWORD_CARD_RADIUS,
  PASSWORD_CARD_SHADOW,
  PASSWORD_CARD_WIDTH,
  PASSWORD_FIELDS_GAP
} from "../change-password-constants";
import PasswordField from "./PasswordField";
import PasswordRequirements from "./PasswordRequirements";
import SubmitButton from "./SubmitButton";

const PasswordForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const oldPassword = getCorePersonalStore().oldPassword.get();
  const newPassword = getCorePersonalStore().newPassword.get();
  const confirmPassword = getCorePersonalStore().confirmPassword.get();

  const checks = getAdminPasswordRuleChecks(newPassword);
  const isMatching =
    isDefinedString(newPassword) && newPassword === confirmPassword;
  const hasConfirmMismatch = isDefinedString(confirmPassword) && !isMatching;
  const isDifferentFromOldPassword =
    isDefinedString(newPassword) && newPassword !== oldPassword;
  const hasNewPasswordError =
    isDefinedString(newPassword) && !isStrongAdminPassword(newPassword);

  const isSubmitEnabled =
    isDefinedString(oldPassword) &&
    isStrongAdminPassword(newPassword) &&
    isDifferentFromOldPassword &&
    isMatching;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={PASSWORD_CARD_WIDTH}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        maxWidth: PASSWORD_CARD_MAX_WIDTH_CSS,
        borderRadius: PASSWORD_CARD_RADIUS * unitX,
        border: PASSWORD_CARD_BORDER,
        boxShadow: PASSWORD_CARD_SHADOW,
        padding: PASSWORD_CARD_MIN_PADDING_CSS,
        gap: PASSWORD_CARD_GAP * unitY
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          gap: PASSWORD_FIELDS_GAP * unitY
        }}
        onClick={() => {}}
      >
        <PasswordField
          label={i18n.get("OLD_PASSWORD")}
          value={oldPassword}
          hasError={false}
          onChoose={(value: string) =>
            getCorePersonalStore().oldPassword.set(value)
          }
        />
        <PasswordField
          label={i18n.get("NEW_PASSWORD")}
          value={newPassword}
          hasError={hasNewPasswordError}
          onChoose={(value: string) =>
            getCorePersonalStore().newPassword.set(value)
          }
        />
        <PasswordField
          label={i18n.get("CONFIRM_PASSWORD")}
          value={confirmPassword}
          hasError={hasConfirmMismatch}
          onChoose={(value: string) =>
            getCorePersonalStore().confirmPassword.set(value)
          }
        />
      </ET3Div>
      <PasswordRequirements
        checks={checks}
        isDifferentFromOldPassword={isDifferentFromOldPassword}
        isMatching={isMatching}
      />
      <SubmitButton
        isEnabled={isSubmitEnabled}
        onPress={() => getCorePersonalStore().changePasswordHandler()}
      />
    </ET3Div>
  );
});
export default PasswordForm;
